import React from 'react'
import BlockWrapper from './MainBlocks/BlockWrapper'

const ApproachServicesList = props => {
  // This is supposed to be a temporary component, which could either turn into a
  // dedicated List block, or could get replaced if the Constellation block
  // is revived. Then, there’d be a
  return (
    <BlockWrapper maxWidth={4} bg="white" color="black">
      <div className="mxn1 lg-mxn2 md-flex flex-auto">
        {props.data.map((parent, parentIndex) => {
          let childItems = null
          let keyPrefix = `ServicesList_${parentIndex}`
          if (parent.items && parent.items.length) {
            childItems = parent.items.map((item, itemIndex) => {
              return (
                <li className="block" key={`${keyPrefix}_${itemIndex}`}>
                  <span className="h5 md-h6 lg-h5 block py1 border-bottom border-gray black">
                    {item}
                  </span>
                </li>
              )
            })

            childItems = (
              <ul className="list-style-none m0 p0 pb2 border-top border-gray">
                {childItems}
              </ul>
            )
          }

          return (
            <div key={keyPrefix} className="col-12 px1 lg-px2 mb2">
              <div className="ApproachServicesList-column">
                <h2 className="h5 line-height-4 magenta">{parent.title}</h2>
                <p>{parent.description}</p>
              </div>
              {childItems}
            </div>
          )
        })}
      </div>
    </BlockWrapper>
  )
}

ApproachServicesList.defaultProps = {
  data: [
    {
      title: 'Plan',
      description:
        'Initial planning stages ensure an accurate understanding of visitor needs and builds awareness for unique site conditions, project dependencies, and regional codes that will guide the design process to successful outcomes.',
      items: [
        'Development Permit Support',
        'Site Assessments',
        'Signage Audits',
        'Stakeholder Consultation',
        'Visitor Journey Analysis',
        'Sign Location Planning',
        'Wayfinding Master Plans',
      ],
    },
    {
      title: 'Design',
      description:
        'Exceptional design reflects the site architecture, community and cultural context, and vision to dramatically impact a visitor’s perception of space, their access to services, and their loyalty to your brand.',
      items: [
        'Communication Design',
        'Industrial Design',
        'Site Branding',
        'Tenant Guidelines',
        'Signage Standards',
        'Technical Specifications',
        'Project Budgeting',
      ],
    },
    {
      title: 'Deliver',
      description:
        'Our project management expertise award us the means to respond to all aspects of a project, managing activities from construction to installation while supporting the needs of our clients and vendors.',
      items: [
        'Construction Documents',
        'Bidding & Tender Support',
        'Vendor Management',
        'Sample & Shop Drawing Review',
        'Installation Oversight',
        'Deficiency Review',
        'Maintenance Planning',
      ],
    },
  ],
}

export default ApproachServicesList
